import * as React from "react";
import pureRender from "pure-render-deepcompare-decorator";
import * as classnames from "classnames";
import * as styles from "./PointInfo.scss";
import {IUserInfo} from "../../IViewObject";
import * as subpub from "../../utils/subpub";

export interface IPointInfoProps{
    /**class */
    className?:string;
    userInfo:IUserInfo;
}

@pureRender
export class PointInfo extends React.Component<IPointInfoProps>{
    constructor(props){
        super(props);
        

        
    }
    public render(){
        const {className,userInfo} =this.props;
        const classNameSec=classnames(styles.sec,className);
        return (
            <div className={classNameSec}>
                剩余支持度：<span className={styles.points}>{userInfo.tickets}</span>
                <div className={styles.fresh} onClick={this.freshUserAndBindInfo}></div>
            </div>
        )
    }

    private freshUserAndBindInfo=()=>{
        subpub.emit('freshUserAndBindInfo');
    }
}

export default PointInfo;


// WEBPACK FOOTER //
// ./src/components/PointInfo/PointInfo.tsx